import Work1 from "../../assets/bondi.png";
import Work2 from "../../assets/dashboard.png";
import Work3 from "../../assets/filter e-commerse.png";
import Work4 from "../../assets/leon.png";
import Work5 from "../../assets/kasper.png";
import Work6 from "../../assets/easy.o.png";
import Work7 from "../../assets/weather.png";
import Work8 from "../../assets/Food-delivery.png";
import Work9 from "../../assets/Netflix-clone.png"

const Menu = [
  {
    id: 1,
    image: Work1,
    title: "Bondi",
    category: "Landing",
    link:"https://omarelnahs.github.io/Bondi/"
  },
  {
    id: 2,
    image: Work2,
    title: "Dashboard",
    category: "Dashboard",
    link:"https://simple-dashboard-io.netlify.app/"
  },
  {
    id: 3,
    image: Work3,
    title: "Filter E-commerce",
    category: "React",
    link:"https://filter-e-commerse-website.netlify.app/"
  },
  {
    id: 4,
    image: Work4,
    title: "Leon",
    category: "landing",
    link:"https://omarelnahs.github.io/Leon/"
  },
  {
    id: 5,
    image: Work5,
    title: "kasper",
    category: "Landing",
    link:"https://omarelnahs.github.io/Kasper/"
  },
  {
    id: 6,
    image: Work6,
    title: "Easy.io",
    category: "Landing",
    link:"https://omarelnahs.github.io/Easy.O/"
  },
  {
    id: 7,
    image: Work7,
    title: "Weather App",
    category: "React",
    link:"https://weather-app-o.netlify.app/"
  }, 
  {
    id: 8,
    image: Work8,
    title: "Food Delivery",
    category: "React",
    link:"https://omarelnahs.github.io/Food-Delivery/"
  },
  {
    id :9,
    image:Work9,
    title:"Netflix Clone",
    category:"React",
    link:"https://omarelnahs.github.io/Netflix-clone/"
  }
];

export default Menu;
